function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Swiper from 'swiper';
var Carousels = /*#__PURE__*/function () {
  function Carousels() {
    _classCallCheck(this, Carousels);
    this.bannerCarousel();
  }
  _createClass(Carousels, [{
    key: "bannerCarousel",
    value: function bannerCarousel() {
      // Initialise the hero carousel
      this.swiper = new Swiper(document.querySelector('.js-banner-carousel'), {
        slidesPerView: 1,
        speed: 400,
        navigation: {
          nextEl: '.c-pagination__next',
          prevEl: '.c-pagination__prev'
        },
        loop: true,
        effect: 'fade',
        // simulateTouch: false,
        keyboardControl: true,
        pagination: {
          el: '.c-pagination__pages',
          type: 'bullets',
          clickable: true,
          bulletClass: 'c-pagination__bullet',
          bulletActiveClass: 'c-pagination__bullet--active',
          renderBullet: function renderBullet(i, className) {
            return "<span class=\"".concat(className, "\">").concat(i + 1, "</span>");
          }
        }
      });
    }
  }]);
  return Carousels;
}();
export { Carousels as default };